import { useEffect, useState } from "react";

const items = [
  {
    key: "SKI",
    caption: "First tracks across untouched north-facing powder.",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20bright%20alpine%20ski%20slope%20under%20clear%20cold%20blue%20sky%2C%20fresh%20untouched%20powder%20glowing%20in%20natural%20daylight%2C%20lone%20skier%20small%20in%20frame%20carving%20down%20open%20snow%20field%2C%20dramatic%20snow%20covered%20peaks%20in%20background%2C%20crisp%20mountain%20light%2C%20editorial%20winter%20sports%20photography%2C%20mineral%20cool%20palette%20of%20snow%20white%20mist%20grey%20sky%20blue%2C%20quiet%20luxury%2C%20fine%20art%20composition%20with%20negative%20space&width=2000&height=1400&seq=exp-ski-bright-03&orientation=landscape",
  },
  {
    key: "HIKE",
    caption: "Open trails through high meadows and quiet ridgelines.",
    image:
      "https://readdy.ai/api/search-image?query=Lush%20green%20alpine%20meadow%20in%20bright%20summer%20daylight%20with%20wildflowers%2C%20two%20hikers%20small%20in%20frame%20walking%20a%20narrow%20trail%20along%20a%20ridgeline%2C%20granite%20peaks%20in%20background%2C%20soft%20drifting%20cloud%2C%20cinematic%20editorial%20outdoor%20photography%2C%20mineral%20palette%20with%20muted%20alpine%20green%20and%20stone%20grey%2C%20natural%20golden%20light%2C%20quiet%20luxury%2C%20fine%20art%20composition%20with%20negative%20space&width=2000&height=1400&seq=exp-hike-meadow-03&orientation=landscape",
  },
  {
    key: "SOAK",
    caption: "Open-air thermal pools set into the mountainside.",
    image:
      "https://readdy.ai/api/search-image?query=Steaming%20outdoor%20thermal%20pool%20cut%20into%20natural%20stone%20on%20a%20mountain%20terrace%2C%20soft%20drifting%20mist%20rising%20from%20warm%20water%2C%20snow%20along%20the%20stone%20edges%2C%20one%20guest%20small%20in%20frame%20in%20linen%20robe%20watching%20alpine%20panorama%2C%20soft%20daylight%2C%20cinematic%20editorial%20luxury%20wellness%20photography%2C%20mineral%20palette%20of%20mist%20white%20glacier%20grey%20muted%20green%2C%20quiet%20luxury%2C%20fine%20art%20composition&width=2000&height=1400&seq=exp-soak-mist-03&orientation=landscape",
  },
  {
    key: "DINE",
    caption: "Fire-driven tasting menus rooted in the season.",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20candlelit%20alpine%20chefs%20table%20with%20open%20wood%20fire%20grill%2C%20plated%20nordic%20tasting%20course%20on%20dark%20ceramic%2C%20natural%20wine%20in%20hand%20blown%20glass%2C%20warm%20amber%20lighting%20from%20fire%20and%20candles%2C%20timber%20and%20stone%20interior%2C%20editorial%20food%20and%20restaurant%20photography%2C%20quiet%20luxury%20dining%2C%20warm%20interior%20palette%2C%20fine%20art%20composition%20with%20negative%20space&width=2000&height=1400&seq=exp-dine-warm-03&orientation=landscape",
  },
  {
    key: "REST",
    caption: "Long mornings, longer silences, wool and firelight.",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20quiet%20alpine%20suite%20interior%20with%20oversized%20linen%20bed%2C%20wool%20throws%2C%20large%20window%20framing%20snowy%20mountain%20peaks%20in%20soft%20morning%20light%2C%20small%20stone%20fireplace%20with%20gentle%20fire%2C%20natural%20oak%20floor%2C%20editorial%20luxury%20hospitality%20photography%2C%20quiet%20luxury%2C%20mineral%20neutral%20palette%20with%20subtle%20warm%20firelight%2C%20fine%20art%20composition%20with%20negative%20space&width=2000&height=1400&seq=exp-rest-window-03&orientation=landscape",
  },
];

export default function Experiences() {
  const [active, setActive] = useState(0);
  const current = items[active];

  // Preload adjacent images for smoother transitions
  useEffect(() => {
    items.forEach((it) => {
      const img = new Image();
      img.src = it.image;
    });
  }, []);

  return (
    <section
      id="experiences"
      className="relative h-screen min-h-[720px] w-full overflow-hidden bg-background-950 text-background-50"
    >
      {/* Full-bleed media stage — one at a time, crossfade */}
      {items.map((it, i) => (
        <div
          key={it.key}
          className="absolute inset-0 transition-opacity duration-[800ms] ease-out"
          style={{ opacity: i === active ? 1 : 0 }}
          aria-hidden={i !== active}
        >
          <img
            src={it.image}
            alt={it.key}
            className="w-full h-full object-cover object-center"
            style={{
              transform: i === active ? "scale(1.03)" : "scale(1.08)",
              transition: "transform 7000ms ease-out",
            }}
          />
        </div>
      ))}

      {/* Very subtle localized gradients only for text legibility */}
      <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-black/25 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-black/45 via-black/15 to-transparent pointer-events-none" />

      {/* Top-left section identifier */}
      <div className="absolute top-28 left-6 md:left-10 z-10 flex items-center gap-4">
        <span className="w-8 h-px bg-background-50/60" />
        <span className="eyebrow text-background-50/85">02 / Experiences</span>
      </div>

      {/* Lower control area */}
      <div className="absolute inset-x-0 bottom-0 z-10 px-6 md:px-10 pb-10 md:pb-12">
        {/* Active supporting sentence */}
        <div key={current.key} className="mb-8 md:mb-10 max-w-xl animate-[expFade_.7s_ease]">
          <div className="font-display text-lg md:text-xl font-light text-background-50 leading-snug">
            {current.caption}
          </div>
        </div>

        {/* Hairline */}
        <div className="h-px w-full bg-background-50/25 mb-5" />

        {/* Labels row */}
        <div
          className="flex items-center gap-8 md:gap-14 overflow-x-auto no-scrollbar"
          role="tablist"
        >
          {items.map((it, i) => {
            const isActive = i === active;
            return (
              <button
                key={it.key}
                role="tab"
                aria-selected={isActive}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`relative group whitespace-nowrap cursor-pointer transition-all duration-500 pb-2 ${
                  isActive
                    ? "text-background-50"
                    : "text-background-50/55 hover:text-background-50/85"
                }`}
              >
                <span
                  className={`font-display tracking-[0.16em] text-[13px] md:text-sm transition-all duration-500 ${
                    isActive ? "font-normal md:text-[15px]" : "font-light"
                  }`}
                >
                  {it.key}
                </span>
                <span
                  className={`absolute left-0 right-0 -bottom-px h-px bg-background-50 origin-left transition-transform duration-500 ${
                    isActive ? "scale-x-100" : "scale-x-0"
                  }`}
                />
              </button>
            );
          })}

          {/* Right-aligned index */}
          <div className="ml-auto hidden md:flex items-center gap-3 text-background-50/70">
            <span className="eyebrow tabular-nums">
              0{active + 1}
            </span>
            <span className="w-6 h-px bg-background-50/40" />
            <span className="eyebrow tabular-nums">0{items.length}</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes expFade {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}